import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { TemplateType } from '@shared/enums'
import { EntityId } from '@reduxjs/toolkit'

export const templateUrl = 'template/'

export interface TemplateModel extends DjangoModel {
  name: string
  isDefault: boolean
  bgAudioSelect: boolean
  templateType: TemplateType
  defaultBgAudio: EntityId
}

const {
  slice: TemplateSlice,
  thunks: TemplateThunks,
  adapter: TemplateAdapter,
  selectors,
} = createGenericSlice<TemplateModel>('template', templateUrl, {})

export const TemplateAdapterExport = TemplateAdapter

export const { selectById: selectTemplateById, selectAll: selectAllTemplates } =
  TemplateAdapter.getSelectors<RootState>((state: RootState) => state.template)

export const { fetchById: fetchTemplateById, fetchAll: fetchAllTemplates } =
  TemplateThunks
export const {
  selectLoading: selectTemplateLoading,
  selectIsIdInProgress: selectIsTemplateIdInProgress,
} = selectors

export default TemplateSlice.reducer
